import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '../../../../tokens.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import { App } from './App';
import { bindAnonymousSignal } from './lib/anonymous-signal';
import './styles.css';
import './components/motion.css';
import './components/interaction-polish.css';
import { MotionProvider } from './components/Motion';

void bindAnonymousSignal();

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 }, mutations: { retry: 0 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <MotionProvider><App /></MotionProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
